export const projectIds = {
  kpk: 'aff1bf53-f002-4e11-a314-0ed6115aea2d',
  mgtc: '1da5af20-4c48-45db-ae9e-54953e010ff0',
  frutella: 'c960b616-7847-472f-9e16-e47941536fd7',
  maybank: '8003d8f9-f107-43ff-bd63-ad432e4d407c',
  danone: '5acbdd88-ea47-43dd-ad17-72f5ecec6a7f'
};
